@use "foundation/colors";
@use "foundation/responsive";
@use "./shared" as shared;

.exclusive_offer_container {
  @include shared.screen-container;
}

.description {
  @include shared.description;
  max-width: 560px;
}

.exclusive-offer-warning {
  font-size: 0.75em;
  font-weight: 600;
}

.offer-card-wrapper {
  margin-top: 40px;
  width: 372px;
  height: 240px;
  border-radius: 24px;
  background-color: colors.$primary-white;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='24' ry='24' stroke='%23222222' stroke-width='6' stroke-dasharray='10,12' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  padding: 3px;
  box-sizing: border-box;

  @include responsive.phone {
    width: 328px;
    height: 210px;
  }
}

.offer-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  background-color: colors.$secondary-blue;
  border-radius: 21px;
}

.offer-card-text {
  font-size: 48px;
  font-weight: 900;
  color: colors.$primary-white;

  @include responsive.phone {
    font-size: 42px;
  }
}

.offer-card-badge {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 70px;
    width: auto;
    fill: colors.$primary-white;

    @include responsive.phone {
      height: 62px;
    }
  }
}
